import type { FC } from 'react'
import React, { memo } from 'react'
import { GlassMorphIcon } from '@/components/ui'
import { messages } from './messages'
import './styles.scss'

const ConsultingRequestSentComponent: FC = () => {
  return (
    <div className="consultingRequestSent">
      <GlassMorphIcon image="success" />
      <h4>{messages.title}</h4>
      <div className="consultingRequestSent__description">{messages.description}</div>
    </div>
  )
}

export const ConsultingRequestSent = memo(ConsultingRequestSentComponent)
